export default __webpack_public_path__ + "static/media/github.8a41e2ec.svg";